// Generic object pool (generalizes v1 js/object-pool.js).

export class Pool<T> {
  private readonly free: T[] = [];

  constructor(
    private readonly create: () => T,
    private readonly reset: (item: T) => void,
    prewarm = 0,
  ) {
    for (let i = 0; i < prewarm; i++) this.free.push(this.create());
  }

  acquire(): T {
    const item = this.free.pop() ?? this.create();
    this.reset(item);
    return item;
  }

  release(item: T): void {
    this.free.push(item);
  }

  get available(): number {
    return this.free.length;
  }
}
